import React, { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CleaningServices } from "@mui/icons-material";
import PolicyIcon from "@mui/icons-material/Policy";
import { Typography } from "@mui/material";
import { blue } from "@mui/material/colors";

import { useSearch } from "hooks/useSearch";
import { useValidateReload } from "hooks/useValidateReload";
import RegularButton from "components/CustomButtons/Button";
import { GlobalBox } from "components/Box/GlobalBox";
import { validateObject } from "helpers/validateObject";

import {
  sendPolicyToOracle,
  newPolicy,
} from "redux/actions/policyManagment/policyManagmentActions";

import { PolicyForm } from "./PolicyForm";

const tableKey = "policyManagments";
const loadings = [
  "policyManagment",
  "search",
  "createPolicy",
  "deletePolicyManagment",
  "sendPolicyToOracle",
  "getPolicyNumber",
  "addMovementToPolicy",
  "editMovementToPolicy",
  "deleteMovementToPolicy",
  "getPolicyAccounts",
];

export const PolicyManagmentView = () => {
  const { buildTableConfig } = useSearch();
  const { policy } = useSelector(({ policyManagment }) => policyManagment);
  const { isLoadingComp } = useSelector(({ search }) => search);
  const dispatch = useDispatch();
  const { configTables } = useSelector(({ search }) => search);
  useValidateReload(loadings);
  useEffect(() => {
    !configTables[tableKey] && buildTableConfig(tableKey);
  }, [configTables[tableKey]]);

  const handleSendToOracle = useCallback(() => {
    dispatch(sendPolicyToOracle(policy.id));
  }, [policy?.id]);

  const handleNewPolicy = useCallback(() => {
    dispatch(newPolicy());
  }, []);

  return (
    <GlobalBox
      title="Poliza movimientos contables"
      icon={<PolicyIcon />}
      controls={
        <>
          {validateObject(policy) && policy.status === "CREATE" && (
            <RegularButton
              color="info"
              onClick={handleSendToOracle}
              loading={isLoadingComp?.sendPolicyToOracle}
            >
              Enviar a Oracle
            </RegularButton>
          )}
          {validateObject(policy) && policy.status === "SEND" && (
            <Typography variant="h5" style={{ color: blue[500] }}>
              Poliza enviada
            </Typography>
          )}
          <RegularButton
            round
            justIcon
            color="info"
            onClick={handleNewPolicy}
            tooltip="Limpiar formulario"
          >
            <CleaningServices style={{ margin: 0 }} />
          </RegularButton>
        </>
      }
    >
      <PolicyForm tableKey={tableKey} />
    </GlobalBox>
  );
};
